import React from 'react';
import tw from 'tailwind-styled-components';
import image1 from '../../../assets/card-images/computer-light.svg'
import image2 from '../../../assets/card-images/360.svg'
import image3 from '../../../assets/card-images/site-cloud.svg'

const Wrapper = tw.div`p-2 text-center col-span-4`;
const ImageWrapper = tw.div`flex mb-4 h-[120px] bg-cover bg-center items-center justify-center`;
const WrapperHeader = tw.div`text-primary font-bold uppercase mb-2`;
const WrapperContent = tw.div`leading-normal`

export default function AboutWhy() {
  return (<div className='grid grid-cols-12 gap-8'>
    <Wrapper>
      <ImageWrapper>
        <img alt="" aria-hidden="true" src={image1} />
      </ImageWrapper>
      <WrapperHeader>
        Increased transparency
      </WrapperHeader>
      <WrapperContent>
      Easily access ACRs to help ensure that the products being purchased meet the varying needs of your users.
      </WrapperContent>
    </Wrapper>
    <Wrapper>
      <ImageWrapper>
        <img alt="" aria-hidden="true" src={image2} />
      </ImageWrapper>
      <WrapperHeader>
        Enhanced visibility
      </WrapperHeader>
      <WrapperContent>
      House ACRs under one roof to help reduce the burden on buyers searching for them when making procurement decisions.
      </WrapperContent>
    </Wrapper>
    <Wrapper>
      <ImageWrapper>
        <img alt="" aria-hidden="true" src={image3} />
      </ImageWrapper>
      <WrapperHeader>
        Access to guidance
      </WrapperHeader>
      <WrapperContent>
      Find resources on how to create the most helpful ACRs and how to review them, as well as where to go when you need help.
      </WrapperContent>
    </Wrapper>
  </div>)
}
